import "./listDetail.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import DatatableTicketDetail from "../../components/datatableTicketDetail/DatatableTicketDetail";

const ListDetail = ({columns}) => {
  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar/>
        <DatatableTicketDetail columns={columns}/>
      </div>
    </div>
  )
}

export default ListDetail